import { render } from "./KalaStoreShared.vue?vue&type=template&id=68bc0f74&scoped=true"
import script from "./KalaStoreShared.vue?vue&type=script&lang=js"
export * from "./KalaStoreShared.vue?vue&type=script&lang=js"

import "./KalaStoreShared.vue?vue&type=style&index=0&id=68bc0f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bc0f74"]])

export default __exports__